import { strings } from '../localization/strings'

export const getErrorString = (error) => {
    if (!error.request) return error.message

    if (!error.response) return strings.exceptions.NetworkError

    var errorData = error.response.data
    if (errorData) {
        if (errorData.error)
            return strings.exceptions[errorData.error]
                ? strings.exceptions[errorData.error]
                : strings.exceptions.DefaultException

        if (errorData.exceptionName) {
            if (strings.exceptions[errorData.exceptionName]) {
                return strings.exceptions[errorData.exceptionName]
            }
            if (errorData.exceptionType === 'ApplicationException') {
                if (errorData.message && errorData.message !== '') {
                    return errorData.message
                }
            }
            return strings.exceptions.DefaultException
        }

        if (errorData.exceptionType)
            return strings.exceptions[errorData.exceptionType]
                ? strings.exceptions[errorData.exceptionType]
                : strings.exceptions.DefaultException

        if (errorData.modelState) {
            var errors = ''
            for (var prop in errorData.modelState) {
                for (var err of errorData.modelState[prop]) {
                    errors += err + '\n'
                }
            }

            return errors
        }

        if (errorData.message) return errorData.message
    }

    return null
}

export const getErrorType = (error) => {
    if (!error.request) return 'RequestError'

    if (!error.response) return 'NetworkError'

    var errorData = error.response.data
    if (errorData) {
        if (errorData.error)
            return strings.exceptions[errorData.error]
                ? errorData.error
                : 'UnknownError'

        if (errorData.exceptionName)
            return strings.exceptions[errorData.exceptionName]
                ? errorData.exceptionName
                : 'UnknownError'

        if (errorData.exceptionType)
            return strings.exceptions[errorData.exceptionType]
                ? errorData.exceptionType
                : 'UnknownError'
    }

    return null
}

export const isRequestUnathorized = (error) => {
    if (
        error != null &&
        error.response != null &&
        error.response.status != null &&
        error.response.status === 401
    )
        return true
    return false
}
